import { request } from "./client";
import type {
  ManagerTeamResponse,
  TeamTimesheetsResponse,
  WorkerWeeklyResponse,
} from "./types";

export async function getManagerTeam(): Promise<ManagerTeamResponse> {
  return request<ManagerTeamResponse>({ method: "GET", url: "/manager/team" });
}

// GET /manager/timesheets — feuilles de l'équipe à valider (défaut submitted+corrected).
export async function getTeamTimesheets(
  status?: string,
): Promise<TeamTimesheetsResponse> {
  return request<TeamTimesheetsResponse>({
    method: "GET",
    url: "/manager/timesheets",
    ...(status ? { params: { status } } : {}),
  });
}

export async function getWorkerWeekly(
  workerUrl: string,
  weekStart: string,
): Promise<WorkerWeeklyResponse> {
  return request<WorkerWeeklyResponse>({
    method: "GET",
    url: `/manager/workers/${encodeURIComponent(workerUrl)}/weekly`,
    params: { week_start: weekStart },
  });
}
